import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IReserveAccountNoModel } from '@apps-common/types/portal/reserve-account-no'

export const getReserveAccountNo = async (mCentreId: string, accountNo: string): Promise<IReserveAccountNoModel> =>
  axios.get(`/accountreservation/reserveaccount?mCentreId=${mCentreId}&accountNo=${accountNo}`).then((res) => res.data?.data)

type Props = {
  mCentreId: string
  accountNo: string
}

export const useReserveAccountNo = (notify?: boolean, onSuccess?: (data: IReserveAccountNoModel) => void) =>
  useMutation({
    mutationKey: ['getReserveAccountNo'],
    mutationFn: ({ mCentreId, accountNo }: Props) => getReserveAccountNo(mCentreId, accountNo),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Reserved account no.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to reserve account no.')
      }
    },
    throwOnError: false
  })
